<template>
    <div class="part">
        <div class="part_header">
            <h1>外协招标——专业的零件采购招标系统</h1>
        </div>
        <div class="part_header_icon container">
            <ul class="icon_part flex">
                <li>
                    <img src="@/assets/images/enquiry1.png" alt="">
                    <p>专业非标零件招标系统</p>
                </li>
                <li>
                    <img src="@/assets/images/enquiry2.png" alt="">
                    <p>电子签图纸高度保密</p>
                </li>
                <li>
                    <img src="@/assets/images/enquiry3.png" alt="">
                    <p>SRM系统智能协同</p>
                </li>
                <li>
                    <img src="@/assets/images/enquiry4.png" alt="">
                    <p>平台海量优质厂商</p>
                </li>
            </ul>
        </div>
        <div class="part_num container">
            <div class="flex">
                <div class="part_item">
                    <ul class="num_box flex">
                        <li>6</li>
                        <li>4</li>
                        <li>9</li>
                    </ul>
                    <p>累计发布招标公告</p>
                </div>
                <div class="part_item">
                    <ul class="num_box flex">
                        <li style="background:#0051A4;">7</li>
                        <li style="background:#0051A4;">8</li>
                        <li style="background:#0051A4;">1</li>
                        <li style="background:#0051A4;">6</li>
                    </ul>
                    <p>入驻厂商</p>
                </div>
            </div>
        </div>
        <div class="statistics-box">
            <el-button round type="primary" @click="goEnquiry">+发布招标</el-button>
            <p>招标系统规则说明</p>
        </div>
        <div class="container" style="margin:30px auto">
            <el-table :data="tableData"  style="width: 100%" class="tables" :stripe="true" >
                <el-table-column prop="id" label="招标编号" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="bid_title" label="招标标题" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="user_name" label="招标公司" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="end_time" label="截止日期" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="create_time" label="发布日期"header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="step" label="状态" header-align="center" align="center">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name:'SetEnquiry',
    data() {
      return {
        tableData: []
      }
    },
    methods:{
        gitBidding(){
            let _this = this;
            this.$http.get('/v2/validate/SearchBidding',{}).then(res =>{
                this.tableData = res.data.map(res => {
                    res.id = _this.changeToStart(res.id,4);
                    res.bid_title = _this.changeToStart(res.bid_title,3);
                    res.user_name = _this.changeToStart(res.user_name,3);
                    return res
                })
               
			}).catch(error =>{
                console.log(error)
				
			})
        },
        changeToStart(str,num){
            let strLen = str.length;
            let stats = '';
            return str.slice(0,str.length - num).padEnd(str.length,'*')
        },
        goEnquiry(){
            this.$router.push({name:'Enquiry'})
        }
    },
    created(){
        this.gitBidding()
    }
}
</script>

<style scoped>
.part{margin-top: 15px;}
.part_header{background-image: linear-gradient(to right, #03a8fd , #003797);}
.part_header h1{font-size: 36px;text-align: center;padding: 85px 0;color: white;font-weight: 500;}
.icon_part{justify-content: space-around;position: relative;margin-top: -35px;margin-bottom: 45px;}
.icon_part li{text-align: center;}
.icon_part p{font-size: 17px;color: #0051a4; margin: 10px 0;font-weight: 600;}
.part_num{padding-bottom: 45px;}
.part_num .part_item{width: 50%;text-align: center;}
.num_box{justify-content: center;}
.num_box li{background-color: #f8a20f;display: inline-block;width: 45px; height: 45px;text-align: center;line-height: 45px;border-radius: 2px; color: #fff;font-size: 24px; margin: 0 5px;}
.part_item p{font-size: 18px;color: #333333;margin-top: 18px;font-weight: bold;}
.statistics-box{text-align: center;}
.statistics-box >>> button{width: 245px;height: 67px;border-radius: 34px;font-size: 24px;color: #ffffff;border: none;outline: none;cursor: pointer;}
.statistics-box p{color: #0051A4;font-size: 14px;margin-top: 10px;}
.tables >>> .el-table__header th{background-color: rgb(197, 212, 235)!important;}
.tables >>> .el-table__header .cell{color: black;}
.tables >>> .el-table__row--striped td{background:rgb(234,243,252)!important;}
</style>